import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_SENTRY_ENV,
  // Enable logs to be sent to Sentry
  enableLogs: true,
  tracesSampleRate: 0.2,
  ignoreErrors: [/Error invoking post: Method not found/],
});
